// Site Configurations for Shop Marriott
// -- These values are unique for each site and rarely need to be changed after initial setup
// -- They are passed to the coreContext in _app.tsx and can be accessed in hah-fe-core via the useContext hook

import type { RumConfig } from '@Hotels-at-Home/hah-fe-core/dist/hooks/useRumScript';

export const csrEmail = 'customer.service@luxurycollectionstore.com';
export const siteName = 'The Luxury Collection Store'; // Used in meta tags, for copy interpolation, etc.
export const parentHotelCompany = 'Marriott';
export const hotelBrandName = 'The Luxury Collection';
export const catalogId = 'LUX';
export const region = 'EU';
export const scandiWebMenuId = 'luxeu';
export const companyTelephone = '+33 1 41 51 54 27';

export const LOGO_IMAGE = { src: '/images/misc/luxury-collection-store-logo_white.svg', alt: '' };

// Product/Category Page Settings
// - imageWidth/imageHeight set the size of the <img /> on cat/prod pages to prevent layout shift
export const product = {
  imageWidth: 1018,
  imageHeight: 792,
  imageWidthThumbnail: 500,
  almaWidget: true,
};

export const category = {
  imageEagerLoadingAmount: 3,
};

export const cart = {
  counterButtons: true,
  drawerContinueShopping: false,
  useCartDrawer: true,
  staticQuantity: true,
  ymalName: 'LUXEU - Cart',
  disableCartYmals: true,
  drawerTotalInBUtton: false,
};

export const checkout = {
  placeholderLabels: true,
  radioButtons: true,
  paymentMethodProceedButton: true,
};

export const header = {
  leftDrawerUtilities: true,
};

// Misc
export const firstVisitModal = {
  modalWidth: 599,
};

// font-family name for the body and heading fonts.
// This is used in "src/ui/layouts/App.tsx" to prevent a flash of text-decorations (ex, line-through) before the font is loaded
export const bodyFontName = 'SofiaProRegular';
export const headingFontName = 'Acta-Medium';

// Adobe Launch Settings
// - Remove these lines completely if this is not a Marriott site
export const enableBonvoyNumber = true;
export const enableMarriottAdobeLaunch = true;
export const enableBonvoyLoyaltyProgramme = true;
export const account = {
  disableAccountDrawer: false,
  enableWelcomeMessage: true,
};
export const marriottAdobeLaunchBrandCode = 'LC';
export const marriottAdobeLaunchBrandName = 'Marriott Hotels & Resorts';

// Google Tag Manager & Analytics Settings
export const enableGoogleTagManager = true;
export const googleTagManagerId = 'GTM-PN9HVRB';
export const productNameFilters = {
  replacements: [{ target: 'The Luxury Collection', replacement: 'Luxury Collection' }],
  splits: [{ split: ' - ', keepIndex: 0 }],
};

// CloudWatch RUM (Real User Monitoring)
// Loaded by useRumScript hook in App.tsx, gated on ConsentMode.analytics
// (OneTrust via Adobe Launch).
// AppMonitor ID and identity pool ID are public identifiers (they ship in the client
// bundle); see cloudwatch-rum-gdpr-investigation.md in hah-docs for rationale.
export const cloudWatchRum: RumConfig = {
  applicationId: '4fa07343-2b7e-412d-9437-1ca916d4f15c',
  region: 'eu-central-1',
  identityPoolId: 'eu-central-1:9a1b3829-11c8-4a06-b474-df9fd49dc0d1',
};

// Cookie Restorer for Safari ITP
export const cookieRestorerEnabled = true;
export const cookieRestorerOptions = { options: { interval: 5000 } };

// Meta Tags
export const googleSiteVerification = '_7o2PoFqdO35igBKVaeEzIT6IBJIHNnS7lgdDLDJpf8';
export const defaultOgImage = '/images/homePage/heroSection/Luxury_Collection_Bed.jpg';

// Links to international sites
export const INTL_SITES = [
  {
    region: 'NA',
    links: [
      {
        value: 'U.S.A.',
        url: 'https://shop.marriott.com/brands/the-luxury-collection.html?referrer=eu',
      },
    ],
  },
];

export const zendeskKey = '086e64bf-6572-4cb6-ad0a-1cfda21a6376';
